import { Injectable } from '@angular/core';

import { CountryI } from './models/country.model';
import { countries } from './data/countries';

@Injectable({
  providedIn: 'root',
})
export class IonIntlTelInputService {
  countryList: CountryI[] = countries;

  getListOfCountries(): CountryI[] {
    return this.countryList;
  }
}
